import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-gray-50 p-3" }
const _hoisted_2 = { class: "max-w-6xl mx-auto" }
const _hoisted_3 = { class: "mb-4" }
const _hoisted_4 = {
  class: "relative rounded-2xl p-4 shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden w-full",
  style: {"background":"linear-gradient(135deg, #10B981 0%, #059669 25%, #047857 50%, #065F46 75%, #064E3B 100%)"}
}
const _hoisted_5 = { class: "relative z-10" }
const _hoisted_6 = { class: "flex items-center space-x-4 mb-3" }
const _hoisted_7 = { class: "text-2xl font-bold text-white" }
const _hoisted_8 = { class: "text-white/90 text-lg font-medium" }
const _hoisted_9 = { class: "mt-4" }
const _hoisted_10 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-6 items-start" }
const _hoisted_11 = { class: "bg-white rounded-2xl border border-gray-200 p-4 shadow-lg hover:shadow-xl transition-shadow duration-300" }
const _hoisted_12 = { class: "flex items-center justify-between mb-4" }
const _hoisted_13 = { class: "flex items-center gap-3" }
const _hoisted_14 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = {
  key: 0,
  class: "text-center py-6"
}
const _hoisted_17 = { class: "text-sm font-medium text-slate-900 dark:text-white mb-1" }
const _hoisted_18 = { class: "text-slate-500 text-xs" }
const _hoisted_19 = {
  key: 1,
  class: "space-y-1.5"
}
const _hoisted_20 = { class: "flex items-center justify-between" }
const _hoisted_21 = { class: "flex items-center gap-2.5" }
const _hoisted_22 = { class: "text-sm font-medium text-slate-900 dark:text-white" }
const _hoisted_23 = { class: "flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "flex gap-2 pt-4 border-t border-gray-200" }
const _hoisted_27 = {
  key: 0,
  class: "flex items-center gap-2 px-4 py-2 bg-green-50 text-green-600 rounded-lg text-sm"
}
const _hoisted_28 = { class: "bg-white rounded-2xl border border-gray-200 p-4 shadow-lg hover:shadow-xl transition-shadow duration-300" }
const _hoisted_29 = { class: "flex items-center justify-between mb-4" }
const _hoisted_30 = { class: "flex items-center gap-3" }
const _hoisted_31 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_32 = { class: "mb-3" }
const _hoisted_33 = {
  key: 0,
  class: "text-center py-6"
}
const _hoisted_34 = { class: "text-sm font-medium text-slate-900 dark:text-white mb-1" }
const _hoisted_35 = { class: "text-slate-500 text-xs" }
const _hoisted_36 = {
  key: 1,
  class: "space-y-1.5"
}
const _hoisted_37 = { class: "flex items-center justify-between" }
const _hoisted_38 = { class: "flex items-center gap-2.5" }
const _hoisted_39 = { class: "text-sm font-medium text-slate-900 dark:text-white" }
const _hoisted_40 = { class: "flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = { class: "flex gap-2 pt-4 border-t border-gray-200" }
const _hoisted_44 = {
  key: 0,
  class: "flex items-center gap-2 px-4 py-2 bg-blue-50 text-blue-600 rounded-lg text-sm"
}
const _hoisted_45 = { class: "lg:col-span-2" }
const _hoisted_46 = { class: "bg-white rounded-2xl border border-gray-200 p-4 shadow-lg hover:shadow-xl transition-shadow duration-300" }
const _hoisted_47 = { class: "mb-6" }
const _hoisted_48 = { class: "flex items-center justify-between mb-4" }
const _hoisted_49 = { class: "flex items-center gap-3" }
const _hoisted_50 = { class: "text-sm font-semibold text-gray-900" }
const _hoisted_51 = { class: "text-xs text-gray-600" }
const _hoisted_52 = { class: "bg-white rounded-xl border border-gray-200 p-4 shadow-sm hover:shadow-md transition-all duration-200 mb-4" }
const _hoisted_53 = { class: "flex items-center justify-between" }
const _hoisted_54 = { class: "flex items-center gap-3" }
const _hoisted_55 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_56 = { class: "text-xs text-gray-500" }
const _hoisted_57 = { class: "flex items-center gap-2" }
const _hoisted_58 = { class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-600" }
const _hoisted_59 = { class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-600" }
const _hoisted_60 = { class: "mt-3 pt-3 border-t border-gray-100" }
const _hoisted_61 = { class: "text-xs font-medium text-gray-700 mb-2" }
const _hoisted_62 = { class: "flex flex-wrap gap-1" }
const _hoisted_63 = { class: "px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs" }
const _hoisted_64 = { class: "px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs" }
const _hoisted_65 = { class: "px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs" }
const _hoisted_66 = { class: "px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs" }
const _hoisted_67 = { class: "px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs" }
const _hoisted_68 = { class: "px-2 py-1 bg-gray-100 text-gray-700 rounded text-xs" }
const _hoisted_69 = {
  key: 0,
  class: "text-center py-8"
}
const _hoisted_70 = { class: "text-sm font-medium text-slate-900 dark:text-white mb-1" }
const _hoisted_71 = { class: "text-xs text-slate-500 dark:text-slate-400 max-w-sm mx-auto" }
const _hoisted_72 = {
  key: 1,
  class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2.5"
}
const _hoisted_73 = { class: "flex items-start justify-between mb-2" }
const _hoisted_74 = { class: "flex-1 min-w-0" }
const _hoisted_75 = { class: "text-xs font-medium text-slate-900 dark:text-white truncate" }
const _hoisted_76 = { class: "text-xs text-slate-500 dark:text-slate-400" }
const _hoisted_77 = { class: "flex items-center gap-0.5" }
const _hoisted_78 = ["onClick"]
const _hoisted_79 = ["onClick"]
const _hoisted_80 = { class: "space-y-1" }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { class: "text-slate-600 dark:text-slate-400 truncate flex-1" }
const _hoisted_83 = { class: "text-slate-400 text-xs shrink-0" }
const _hoisted_84 = {
  key: 0,
  class: "text-xs text-slate-400 ml-3"
}
const _hoisted_85 = {
  key: 1,
  class: "text-xs text-slate-400 italic"
}
const _hoisted_86 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_87 = { class: "bg-white rounded-xl shadow-2xl w-full max-w-lg mx-4 z-10 relative border border-gray-200 max-h-[85vh] overflow-hidden" }
const _hoisted_88 = {
  class: "px-6 py-4",
  style: {"background":"linear-gradient(135deg, #10B981 0%, #059669 50%, #047857 100%)"}
}
const _hoisted_89 = { class: "flex items-center justify-between" }
const _hoisted_90 = { class: "flex items-center gap-3" }
const _hoisted_91 = { class: "text-lg font-semibold text-white" }
const _hoisted_92 = { class: "text-white/90 text-sm" }
const _hoisted_93 = { class: "p-6 space-y-6" }
const _hoisted_94 = { class: "space-y-4" }
const _hoisted_95 = { class: "block text-sm font-semibold text-gray-900 mb-2" }
const _hoisted_96 = ["placeholder"]
const _hoisted_97 = { class: "block text-sm font-semibold text-gray-900 mb-2" }
const _hoisted_98 = { class: "flex items-center gap-3" }
const _hoisted_99 = { class: "flex-1" }
const _hoisted_100 = { class: "flex items-center gap-2 p-3 bg-gray-50 rounded-lg border border-gray-200" }
const _hoisted_101 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_102 = { class: "text-xs text-gray-500" }
const _hoisted_103 = { class: "px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between" }
const _hoisted_104 = { class: "flex gap-2" }
const _hoisted_105 = ["disabled"]
const _hoisted_106 = {
  key: 1,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_107 = { class: "bg-white rounded-xl shadow-2xl w-full max-w-lg mx-4 z-10 relative border border-gray-200 max-h-[85vh] overflow-hidden" }
const _hoisted_108 = {
  class: "px-6 py-4",
  style: {"background":"linear-gradient(135deg, #3B82F6 0%, #2563EB 50%, #1D4ED8 100%)"}
}
const _hoisted_109 = { class: "flex items-center justify-between" }
const _hoisted_110 = { class: "flex items-center gap-3" }
const _hoisted_111 = { class: "text-lg font-semibold text-white" }
const _hoisted_112 = { class: "text-white/90 text-sm" }
const _hoisted_113 = { class: "p-6 space-y-6" }
const _hoisted_114 = { class: "block text-sm font-semibold text-gray-900 mb-2" }
const _hoisted_115 = ["placeholder"]
const _hoisted_116 = { class: "p-3 bg-gray-50 rounded-lg border border-gray-200" }
const _hoisted_117 = { class: "flex items-center gap-2" }
const _hoisted_118 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_119 = { class: "pt-4 flex items-center justify-between" }
const _hoisted_120 = { class: "flex gap-2" }
const _hoisted_121 = ["disabled"]
const _hoisted_122 = {
  key: 2,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_123 = { class: "bg-white rounded-xl shadow-2xl w-full max-w-lg mx-4 z-10 relative border border-gray-200 max-h-[85vh] overflow-hidden" }
const _hoisted_124 = {
  class: "px-6 py-4",
  style: {"background":"linear-gradient(135deg, #DC2626 0%, #B91C1C 50%, #991B1B 100%)"}
}
const _hoisted_125 = { class: "flex items-center justify-between" }
const _hoisted_126 = { class: "flex items-center gap-3" }
const _hoisted_127 = { class: "text-lg font-semibold text-white" }
const _hoisted_128 = { class: "p-6 space-y-6" }
const _hoisted_129 = { class: "text-center" }
const _hoisted_130 = { class: "text-lg font-semibold text-gray-900 mb-2" }
const _hoisted_131 = { class: "text-gray-600 text-sm" }
const _hoisted_132 = { class: "p-4 bg-red-50 border border-red-200 rounded-lg" }
const _hoisted_133 = { class: "flex items-start gap-3" }
const _hoisted_134 = { class: "text-red-800" }
const _hoisted_135 = { class: "text-sm text-red-700" }
const _hoisted_136 = { class: "px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between" }
const _hoisted_137 = { class: "flex gap-2" }
const _hoisted_138 = {
  key: 3,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_139 = { class: "bg-white rounded-xl shadow-2xl w-full max-w-2xl mx-4 z-10 relative border border-gray-200 max-h-[80vh] overflow-hidden" }
const _hoisted_140 = {
  key: 0,
  class: "flex flex-col h-full"
}
const _hoisted_141 = {
  class: "px-6 py-4",
  style: {"background":"linear-gradient(135deg, #10B981 0%, #059669 50%, #047857 100%)"}
}
const _hoisted_142 = { class: "flex items-center justify-between" }
const _hoisted_143 = { class: "flex items-center gap-3" }
const _hoisted_144 = { class: "text-lg font-semibold text-white" }
const _hoisted_145 = { class: "text-white/90 text-sm" }
const _hoisted_146 = { class: "flex-1 p-6" }
const _hoisted_147 = { class: "max-w-md mx-auto" }
const _hoisted_148 = { class: "text-center mb-6" }
const _hoisted_149 = { class: "text-lg font-semibold text-gray-900 mb-2" }
const _hoisted_150 = { class: "text-gray-600" }
const _hoisted_151 = { class: "space-y-4" }
const _hoisted_152 = { class: "block text-sm font-semibold text-gray-900 mb-2" }
const _hoisted_153 = ["placeholder"]
const _hoisted_154 = { class: "mt-6 p-4 bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg border border-gray-200" }
const _hoisted_155 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_156 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_157 = { class: "text-xs text-gray-500" }
const _hoisted_158 = { class: "text-xs text-gray-500" }
const _hoisted_159 = { class: "px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between" }
const _hoisted_160 = { class: "text-xs text-gray-500" }
const _hoisted_161 = { class: "flex gap-2" }
const _hoisted_162 = ["disabled"]
const _hoisted_163 = {
  key: 1,
  class: "flex h-[80vh]"
}
const _hoisted_164 = { class: "w-1/2 border-r border-gray-200 flex flex-col bg-gray-50" }
const _hoisted_165 = {
  class: "px-4 py-3",
  style: {"background":"linear-gradient(135deg, #3B82F6 0%, #2563EB 50%, #1D4ED8 100%)"}
}
const _hoisted_166 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_167 = { class: "text-sm font-semibold text-white" }
const _hoisted_168 = { class: "text-white/90 text-xs" }
const _hoisted_169 = { class: "flex-1 p-3 overflow-y-auto" }
const _hoisted_170 = { class: "grid grid-cols-1 gap-2" }
const _hoisted_171 = ["onClick"]
const _hoisted_172 = { class: "flex items-center gap-2" }
const _hoisted_173 = { class: "w-8 h-8 bg-blue-100 group-hover:bg-blue-200 rounded flex items-center justify-center transition-colors duration-200" }
const _hoisted_174 = {
  class: "w-4 h-4 text-blue-600",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_175 = ["d"]
const _hoisted_176 = { class: "text-sm font-medium text-gray-900 group-hover:text-blue-600 transition-colors duration-200" }
const _hoisted_177 = { class: "text-xs text-gray-500" }
const _hoisted_178 = { class: "w-1/2 flex flex-col bg-white" }
const _hoisted_179 = {
  class: "px-4 py-3",
  style: {"background":"linear-gradient(135deg, #10B981 0%, #059669 50%, #047857 100%)"}
}
const _hoisted_180 = { class: "flex items-center justify-between" }
const _hoisted_181 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_182 = { class: "text-sm font-semibold text-white" }
const _hoisted_183 = { class: "text-white/90 text-xs" }
const _hoisted_184 = ["disabled"]
const _hoisted_185 = { class: "flex-1 p-3 overflow-y-auto" }
const _hoisted_186 = {
  key: 0,
  class: "text-center py-8"
}
const _hoisted_187 = { class: "text-sm font-medium text-gray-900 mb-1" }
const _hoisted_188 = { class: "text-xs text-gray-500" }
const _hoisted_189 = {
  key: 1,
  class: "space-y-2"
}
const _hoisted_190 = { class: "flex items-start justify-between" }
const _hoisted_191 = { class: "flex-1 min-w-0" }
const _hoisted_192 = { class: "flex items-center gap-2 mb-1" }
const _hoisted_193 = { class: "flex-1" }
const _hoisted_194 = { class: "flex items-center gap-2" }
const _hoisted_195 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_196 = {
  key: 0,
  class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800"
}
const _hoisted_197 = { class: "flex items-center gap-2 mt-0.5" }
const _hoisted_198 = { class: "text-xs text-gray-600" }
const _hoisted_199 = { class: "text-xs text-gray-500 truncate" }
const _hoisted_200 = { class: "flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200" }
const _hoisted_201 = ["onClick"]
const _hoisted_202 = ["onClick"]
const _hoisted_203 = { class: "px-4 py-3 bg-gray-50 border-t border-gray-200 flex items-center justify-between" }
const _hoisted_204 = { class: "text-xs text-gray-500" }
const _hoisted_205 = { class: "font-medium" }
const _hoisted_206 = {
  key: 4,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_207 = { class: "bg-white dark:bg-slate-800 rounded-lg shadow-xl w-full max-w-6xl mx-4 z-10 relative max-h-[85vh] overflow-hidden border border-slate-200 dark:border-slate-700" }
const _hoisted_208 = { class: "px-4 py-3 border-b border-slate-200 dark:border-slate-700" }
const _hoisted_209 = { class: "flex items-center justify-between" }
const _hoisted_210 = { class: "text-sm font-semibold text-slate-900 dark:text-white" }
const _hoisted_211 = { class: "flex h-[calc(85vh-80px)]" }
const _hoisted_212 = { class: "flex-1 p-4 overflow-y-auto" }
const _hoisted_213 = { class: "grid grid-cols-2 md:grid-cols-3 gap-3" }
const _hoisted_214 = ["onClick"]
const _hoisted_215 = ["d"]
const _hoisted_216 = { class: "text-xs font-medium text-slate-900 dark:text-white mb-1" }
const _hoisted_217 = { class: "text-xs text-slate-500 dark:text-slate-400 leading-relaxed" }
const _hoisted_218 = { class: "w-80 border-l border-slate-200 dark:border-slate-700 p-4 bg-slate-50 dark:bg-slate-800/50" }
const _hoisted_219 = { class: "flex items-center justify-between mb-3" }
const _hoisted_220 = { class: "text-xs text-slate-500 dark:text-slate-400" }
const _hoisted_221 = { class: "bg-white dark:bg-slate-800 rounded-lg border border-slate-200 dark:border-slate-700 p-3 mb-4" }
const _hoisted_222 = { class: "flex items-center gap-2 mb-3 pb-2 border-b border-slate-200 dark:border-slate-700" }
const _hoisted_223 = { class: "text-sm font-medium text-slate-900 dark:text-white" }
const _hoisted_224 = {
  key: 0,
  class: "text-center py-6"
}
const _hoisted_225 = {
  key: 1,
  class: "space-y-2"
}
const _hoisted_226 = ["d"]
const _hoisted_227 = { class: "flex-1 min-w-0" }
const _hoisted_228 = { class: "text-xs font-medium text-slate-900 dark:text-white truncate" }
const _hoisted_229 = { class: "text-xs text-slate-500 dark:text-slate-400" }
const _hoisted_230 = ["onClick"]
const _hoisted_231 = ["disabled"]
const _hoisted_232 = {
  key: 5,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_233 = { class: "bg-white dark:bg-gray-900 rounded-2xl shadow-xl w-full max-w-2xl mx-4 z-10 relative max-h-[85vh] overflow-hidden" }
const _hoisted_234 = { class: "relative overflow-hidden" }
const _hoisted_235 = { class: "relative px-4 py-3 border-b border-slate-200/50 dark:border-slate-700/50" }
const _hoisted_236 = { class: "flex items-center justify-between" }
const _hoisted_237 = { class: "flex items-center gap-3" }
const _hoisted_238 = ["d"]
const _hoisted_239 = { class: "text-lg font-semibold text-slate-900 dark:text-white" }
const _hoisted_240 = { class: "p-4 overflow-y-auto max-h-[calc(85vh-120px)] bg-slate-50/30 dark:bg-slate-900/30" }
const _hoisted_241 = { class: "bg-white dark:bg-slate-800 rounded-lg p-4 shadow-sm border border-slate-200/50 dark:border-slate-700/50" }
const _hoisted_242 = ["placeholder"]
const _hoisted_243 = { class: "bg-white dark:bg-slate-800 rounded-lg p-4 shadow-sm border border-slate-200/50 dark:border-slate-700/50" }
const _hoisted_244 = { class: "flex items-center justify-between" }
const _hoisted_245 = { class: "relative" }
const _hoisted_246 = {
  for: "fieldRequired",
  class: "flex items-center cursor-pointer"
}
const _hoisted_247 = { class: "relative" }
const _hoisted_248 = {
  key: 0,
  class: "bg-white dark:bg-slate-800 rounded-lg p-4 shadow-sm border border-slate-200/50 dark:border-slate-700/50"
}
const _hoisted_249 = { class: "grid grid-cols-1 md:grid-cols-2 gap-3" }
const _hoisted_250 = {
  key: 1,
  class: "bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-sm border border-slate-200/50 dark:border-slate-700/50"
}
const _hoisted_251 = { class: "grid grid-cols-1 md:grid-cols-3 gap-4" }
const _hoisted_252 = {
  key: 2,
  class: "bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-sm border border-slate-200/50 dark:border-slate-700/50"
}
const _hoisted_253 = { class: "flex items-start gap-4 mb-6" }
const _hoisted_254 = { class: "text-lg font-bold text-slate-900 dark:text-white" }
const _hoisted_255 = { class: "text-sm text-slate-600 dark:text-slate-400" }
const _hoisted_256 = { class: "space-y-3 mb-4" }
const _hoisted_257 = { class: "flex-1" }
const _hoisted_258 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_259 = ["onClick", "disabled"]
const _hoisted_260 = {
  key: 3,
  class: "bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-sm border border-slate-200/50 dark:border-slate-700/50"
}
const _hoisted_261 = {
  key: 4,
  class: "bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-sm border border-slate-200/50 dark:border-slate-700/50"
}
const _hoisted_262 = {
  key: 5,
  class: "bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-sm border border-slate-200/50 dark:border-slate-700/50"
}
const _hoisted_263 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_264 = {
  key: 6,
  class: "bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-sm border border-slate-200/50 dark:border-slate-700/50"
}
const _hoisted_265 = { class: "space-y-4" }
const _hoisted_266 = {
  key: 7,
  class: "bg-white dark:bg-slate-800 rounded-2xl p-6 shadow-sm border border-slate-200/50 dark:border-slate-700/50"
}
const _hoisted_267 = { class: "flex items-start gap-4" }
const _hoisted_268 = ["d"]
const _hoisted_269 = { class: "text-lg font-bold text-slate-900 dark:text-white mb-2" }
const _hoisted_270 = { class: "bg-slate-50 dark:bg-slate-900 rounded-xl p-4 border border-slate-200 dark:border-slate-700" }
const _hoisted_271 = { class: "text-sm text-slate-600 dark:text-slate-400 mb-2" }
const _hoisted_272 = { key: 0 }
const _hoisted_273 = { key: 1 }
const _hoisted_274 = { key: 2 }
const _hoisted_275 = { key: 3 }
const _hoisted_276 = { key: 4 }
const _hoisted_277 = { key: 5 }
const _hoisted_278 = { class: "px-4 py-3 border-t border-slate-200/50 dark:border-slate-700/50 bg-white dark:bg-slate-800" }
const _hoisted_279 = { class: "flex items-center justify-end gap-3" }
const _hoisted_280 = {
  key: 6,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_281 = { class: "bg-white rounded-xl shadow-2xl w-full max-w-lg mx-4 z-10 relative border border-gray-200 max-h-[85vh] overflow-hidden" }
const _hoisted_282 = {
  class: "px-6 py-4",
  style: {"background":"linear-gradient(135deg, #10B981 0%, #059669 50%, #047857 100%)"}
}
const _hoisted_283 = { class: "flex items-center justify-between" }
const _hoisted_284 = { class: "flex items-center gap-3" }
const _hoisted_285 = { class: "text-lg font-semibold text-white" }
const _hoisted_286 = { class: "text-white/90 text-sm" }
const _hoisted_287 = { class: "p-6 space-y-4 max-h-[70vh] overflow-y-auto" }
const _hoisted_288 = { class: "block text-sm font-semibold text-gray-900 mb-2" }
const _hoisted_289 = ["placeholder"]
const _hoisted_290 = { class: "mt-6 p-4 bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg border border-gray-200" }
const _hoisted_291 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_292 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_293 = { class: "text-xs text-gray-500" }
const _hoisted_294 = { class: "text-xs text-gray-500" }
const _hoisted_295 = { class: "px-6 py-4 bg-gray-50 border-t border-gray-200 flex items-center justify-between" }
const _hoisted_296 = { class: "text-xs text-gray-500" }
const _hoisted_297 = { class: "flex gap-2" }
const _hoisted_298 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SettingsNav = _resolveComponent("SettingsNav")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[54] || (_cache[54] = _createElementVNode("div", { class: "absolute inset-0 overflow-hidden" }, [
            _createElementVNode("div", {
              class: "absolute -top-20 -right-20 w-40 h-40 rounded-full opacity-20",
              style: {"background":"radial-gradient(circle, rgba(255,255,255,0.3) 0%, transparent 70%)"}
            })
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[53] || (_cache[53] = _createElementVNode("div", { class: "relative flex-shrink-0" }, [
                _createElementVNode("div", {
                  class: "w-16 h-16 rounded-full flex items-center justify-center border-3 border-white/70 shadow-xl",
                  style: {"background":"linear-gradient(135deg, #FFFFFF 0%, #F8FAFC 100%)"}
                }, [
                  _createElementVNode("svg", {
                    class: "w-8 h-8 text-green-600",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M9 5H7a2 2 0 00-2 2v6a2 2 0 002 2h2m5 0h2a2 2 0 002-2V7a2 2 0 00-2-2h-2m-5 4v2m0 0v2m0-2h2m-2 0H9"
                    })
                  ])
                ])
              ], -1)),
              _createElementVNode("div", null, [
                _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.directT('settings.leadsSettings.title')), 1),
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.directT('settings.leadsSettings.subtitle')), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_SettingsNav)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[55] || (_cache[55] = _createElementVNode("div", {
                class: "w-8 h-8 rounded-lg flex items-center justify-center",
                style: {"background-color":"#059669"}
              }, [
                _createElementVNode("svg", {
                  class: "w-4 h-4 text-white",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                  })
                ])
              ], -1)),
              _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.directT('settings.leadsSettings.statusManagement.title')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            (_ctx.statusList.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _cache[56] || (_cache[56] = _createElementVNode("div", { class: "w-10 h-10 bg-slate-100 dark:bg-slate-700 rounded-lg flex items-center justify-center mx-auto mb-3" }, [
                    _createElementVNode("svg", {
                      class: "w-5 h-5 text-slate-400",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("h4", _hoisted_17, _toDisplayString(_ctx.directT('settings.leadsSettings.statusManagement.noStatuses')), 1),
                  _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.directT('settings.leadsSettings.statusManagement.noStatusesDescription')), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusList, (status, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: status.id,
                      class: "group bg-slate-50 dark:bg-slate-700/50 rounded-md border border-slate-200 dark:border-slate-600 p-2.5 hover:bg-slate-100 dark:hover:bg-slate-700 transition-all duration-200"
                    }, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", {
                            class: "w-4 h-4 rounded-full",
                            style: _normalizeStyle({ backgroundColor: status.color })
                          }, null, 4),
                          _createElementVNode("span", _hoisted_22, _toDisplayString(status.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.editStatus(index)),
                            class: "w-6 h-6 rounded bg-slate-200 hover:bg-slate-300 dark:bg-slate-600 dark:hover:bg-slate-500 text-slate-600 dark:text-slate-300 transition-all duration-200 flex items-center justify-center"
                          }, _cache[57] || (_cache[57] = [
                            _createElementVNode("svg", {
                              class: "w-3 h-3",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                              })
                            ], -1)
                          ]), 8, _hoisted_24),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.deleteStatus(index)),
                            class: "w-6 h-6 rounded bg-red-100 hover:bg-red-200 dark:bg-red-900/30 dark:hover:bg-red-900/50 text-red-600 dark:text-red-400 transition-all duration-200 flex items-center justify-center"
                          }, _cache[58] || (_cache[58] = [
                            _createElementVNode("svg", {
                              class: "w-3 h-3",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                              })
                            ], -1)
                          ]), 8, _hoisted_25)
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addNewStatus && _ctx.addNewStatus(...args))),
              class: "flex-1 px-4 py-2 text-white rounded-lg font-medium text-sm transition-all duration-200 flex items-center justify-center gap-2 shadow-md hover:shadow-lg",
              style: {"background":"linear-gradient(135deg, #10B981 0%, #059669 100%)"}
            }, [
              _cache[59] || (_cache[59] = _createElementVNode("svg", {
                class: "w-4 h-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.leadsSettings.statusManagement.addStatus')), 1)
            ]),
            (_ctx.saving)
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _cache[60] || (_cache[60] = _createElementVNode("svg", {
                    class: "w-4 h-4 animate-spin",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                    })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.leadsSettings.autoSaving')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _cache[61] || (_cache[61] = _createElementVNode("div", {
                class: "w-8 h-8 rounded-lg flex items-center justify-center",
                style: {"background-color":"#3B82F6"}
              }, [
                _createElementVNode("svg", {
                  class: "w-4 h-4 text-white",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                  })
                ])
              ], -1)),
              _createElementVNode("h3", _hoisted_31, _toDisplayString(_ctx.directT('settings.leadsSettings.sourceManagement.title')), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            (_ctx.sourceList.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                  _cache[62] || (_cache[62] = _createElementVNode("div", { class: "w-10 h-10 bg-slate-100 dark:bg-slate-700 rounded-lg flex items-center justify-center mx-auto mb-3" }, [
                    _createElementVNode("svg", {
                      class: "w-5 h-5 text-slate-400",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("h4", _hoisted_34, _toDisplayString(_ctx.directT('settings.leadsSettings.sourceManagement.noSources')), 1),
                  _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.directT('settings.leadsSettings.sourceManagement.noSourcesDescription')), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sourceList, (source, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: source.id,
                      class: "group bg-slate-50 dark:bg-slate-700/50 rounded-md border border-slate-200 dark:border-slate-600 p-2.5 hover:bg-slate-100 dark:hover:bg-slate-700 transition-all duration-200"
                    }, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _cache[63] || (_cache[63] = _createElementVNode("div", { class: "w-4 h-4 bg-emerald-100 dark:bg-emerald-900/30 rounded flex items-center justify-center" }, [
                            _createElementVNode("svg", {
                              class: "w-2.5 h-2.5 text-emerald-600 dark:text-emerald-400",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                              })
                            ])
                          ], -1)),
                          _createElementVNode("span", _hoisted_39, _toDisplayString(source.name), 1)
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.editSource(index)),
                            class: "w-6 h-6 rounded bg-slate-200 hover:bg-slate-300 dark:bg-slate-600 dark:hover:bg-slate-500 text-slate-600 dark:text-slate-300 transition-all duration-200 flex items-center justify-center"
                          }, _cache[64] || (_cache[64] = [
                            _createElementVNode("svg", {
                              class: "w-3 h-3",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                              })
                            ], -1)
                          ]), 8, _hoisted_41),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.deleteSource(index)),
                            class: "w-6 h-6 rounded bg-red-100 hover:bg-red-200 dark:bg-red-900/30 dark:hover:bg-red-900/50 text-red-600 dark:text-red-400 transition-all duration-200 flex items-center justify-center"
                          }, _cache[65] || (_cache[65] = [
                            _createElementVNode("svg", {
                              class: "w-3 h-3",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                              })
                            ], -1)
                          ]), 8, _hoisted_42)
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
          ]),
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addNewSource && _ctx.addNewSource(...args))),
              class: "flex-1 px-4 py-2 text-white rounded-lg font-medium text-sm transition-all duration-200 flex items-center justify-center gap-2 shadow-md hover:shadow-lg",
              style: {"background":"linear-gradient(135deg, #3B82F6 0%, #1E40AF 100%)"}
            }, [
              _cache[66] || (_cache[66] = _createElementVNode("svg", {
                class: "w-4 h-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                })
              ], -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.leadsSettings.sourceManagement.addSource')), 1)
            ]),
            (_ctx.saving)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _cache[67] || (_cache[67] = _createElementVNode("svg", {
                    class: "w-4 h-4 animate-spin",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                    })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.leadsSettings.autoSaving')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _cache[68] || (_cache[68] = _createElementVNode("div", {
                    class: "w-8 h-8 rounded-lg flex items-center justify-center",
                    style: {"background":"linear-gradient(135deg, #10B981, #059669)"}
                  }, [
                    _createElementVNode("svg", {
                      class: "w-4 h-4 text-white",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("h4", _hoisted_50, _toDisplayString(_ctx.directT('settings.leadsSettings.existingCards.title')), 1),
                    _createElementVNode("p", _hoisted_51, _toDisplayString(_ctx.directT('settings.leadsSettings.existingCards.description')), 1)
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addNewCard && _ctx.addNewCard(...args))),
                  class: "px-4 py-2 text-white text-sm font-medium rounded-lg transition-all duration-200 flex items-center gap-2 shadow-md hover:shadow-lg transform hover:scale-105",
                  style: {"background":"linear-gradient(135deg, #10B981, #059669)"}
                }, [
                  _cache[69] || (_cache[69] = _createElementVNode("svg", {
                    class: "w-4 h-4",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                    })
                  ], -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.leadsSettings.existingCards.addNewCard')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _cache[70] || (_cache[70] = _createElementVNode("div", { class: "w-8 h-8 rounded-lg bg-blue-100 flex items-center justify-center" }, [
                      _createElementVNode("svg", {
                        class: "w-4 h-4 text-blue-600",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                        })
                      ])
                    ], -1)),
                    _createElementVNode("div", null, [
                      _createElementVNode("h5", _hoisted_55, _toDisplayString(_ctx.directT('settings.leadsSettings.existingCards.basicLeadInfo.title')), 1),
                      _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.directT('settings.leadsSettings.existingCards.basicLeadInfo.description')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.directT('settings.leadsSettings.existingCards.basicLeadInfo.active')), 1),
                    _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.directT('settings.leadsSettings.existingCards.basicLeadInfo.builtIn')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.directT('settings.leadsSettings.existingCards.basicLeadInfo.includedFields')), 1),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.directT('settings.leadsSettings.existingCards.basicLeadInfo.fullName')), 1),
                    _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.directT('settings.leadsSettings.existingCards.basicLeadInfo.email')), 1),
                    _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.directT('settings.leadsSettings.existingCards.basicLeadInfo.phone')), 1),
                    _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.directT('settings.leadsSettings.existingCards.basicLeadInfo.company')), 1),
                    _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.directT('settings.leadsSettings.existingCards.basicLeadInfo.status')), 1),
                    _createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.directT('settings.leadsSettings.existingCards.basicLeadInfo.source')), 1)
                  ])
                ])
              ])
            ]),
            (_ctx.systemAreas.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                  _cache[71] || (_cache[71] = _createElementVNode("div", { class: "mx-auto w-12 h-12 bg-slate-100 dark:bg-slate-700 rounded-lg flex items-center justify-center mb-3" }, [
                    _createElementVNode("svg", {
                      class: "w-6 h-6 text-slate-400",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "1.5",
                        d: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("h4", _hoisted_70, _toDisplayString(_ctx.directT('settings.leadsSettings.existingCards.noAdditionalCards')), 1),
                  _createElementVNode("p", _hoisted_71, _toDisplayString(_ctx.directT('settings.leadsSettings.existingCards.createCustomCards')), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_72, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.systemAreas, (area, areaIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: area.id,
                      class: "bg-slate-50 dark:bg-slate-700/50 rounded-md border border-slate-200 dark:border-slate-600 p-3 hover:border-slate-300 dark:hover:border-slate-500 transition-colors"
                    }, [
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("div", _hoisted_74, [
                          _createElementVNode("h3", _hoisted_75, _toDisplayString(area.title), 1),
                          _createElementVNode("p", _hoisted_76, _toDisplayString(area.fields.length) + " fields", 1)
                        ]),
                        _createElementVNode("div", _hoisted_77, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.editArea(areaIndex)),
                            class: "p-1 text-slate-400 hover:text-slate-600 hover:bg-slate-200 dark:hover:bg-slate-600 rounded transition-colors"
                          }, _cache[72] || (_cache[72] = [
                            _createElementVNode("svg", {
                              class: "w-3 h-3",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "1.5",
                                d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                              })
                            ], -1)
                          ]), 8, _hoisted_78),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (_ctx.deleteArea(areaIndex)),
                            class: "p-1 text-slate-400 hover:text-red-600 hover:bg-red-100 dark:hover:bg-red-900/30 rounded transition-colors"
                          }, _cache[73] || (_cache[73] = [
                            _createElementVNode("svg", {
                              class: "w-3 h-3",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "1.5",
                                d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                              })
                            ], -1)
                          ]), 8, _hoisted_79)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_80, [
                        (area.fields.length > 0)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(area.fields.slice(0, 2), (field) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: field.id,
                                  class: "flex items-center gap-1.5 text-xs"
                                }, [
                                  _cache[74] || (_cache[74] = _createElementVNode("div", { class: "w-1.5 h-1.5 rounded-full bg-slate-400" }, null, -1)),
                                  _createElementVNode("span", _hoisted_82, _toDisplayString(field.label), 1),
                                  _createElementVNode("span", _hoisted_83, _toDisplayString(_ctx.getFieldTypeLabel(field.type)), 1)
                                ]))
                              }), 128)),
                              (area.fields.length > 2)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_84, " +" + _toDisplayString(area.fields.length - 2) + " more ", 1))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_85, " No fields configured "))
                      ])
                    ]))
                  }), 128))
                ]))
          ])
        ])
      ])
    ]),
    (_ctx.showStatusModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/30 backdrop-blur-md",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeStatusModal && _ctx.closeStatusModal(...args)))
          }),
          _createElementVNode("div", _hoisted_87, [
            _createElementVNode("div", _hoisted_88, [
              _createElementVNode("div", _hoisted_89, [
                _createElementVNode("div", _hoisted_90, [
                  _cache[75] || (_cache[75] = _createElementVNode("div", { class: "w-8 h-8 bg-white/30 rounded-lg flex items-center justify-center border border-white/20" }, [
                    _createElementVNode("svg", {
                      class: "w-4 h-4 text-white",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_91, _toDisplayString(_ctx.editingStatusIndex === -1 ? _ctx.directT('settings.leadsSettings.statusManagement.addStatusTitle') : _ctx.directT('settings.leadsSettings.statusManagement.editStatusTitle')), 1),
                    _createElementVNode("p", _hoisted_92, _toDisplayString(_ctx.editingStatusIndex === -1 ? 'Create a new lead status' : 'Update lead status settings'), 1)
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeStatusModal && _ctx.closeStatusModal(...args))),
                  class: "w-8 h-8 bg-white/30 hover:bg-white/40 rounded-lg flex items-center justify-center transition-all duration-200 border border-white/20"
                }, _cache[76] || (_cache[76] = [
                  _createElementVNode("svg", {
                    class: "w-4 h-4 text-white",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_93, [
              _cache[77] || (_cache[77] = _createStaticVNode("<div class=\"text-center\" data-v-0124dbfa><div class=\"w-16 h-16 bg-gradient-to-br from-green-100 to-emerald-100 rounded-xl flex items-center justify-center mx-auto mb-4 shadow-md\" data-v-0124dbfa><svg class=\"w-8 h-8 text-green-600\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-0124dbfa><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z\" data-v-0124dbfa></path></svg></div><h4 class=\"text-lg font-semibold text-gray-900 mb-2\" data-v-0124dbfa>Lead Status Configuration</h4><p class=\"text-gray-600 text-sm\" data-v-0124dbfa>Configure the status name and visual appearance for your leads</p></div>", 1)),
              _createElementVNode("div", _hoisted_94, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.directT('settings.leadsSettings.statusManagement.statusName')), 1),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editingStatus.name) = $event)),
                    type: "text",
                    class: "w-full px-3 py-2.5 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-green-100 focus:border-green-500 bg-gray-50 text-gray-900 transition-all duration-300 placeholder:text-gray-400",
                    placeholder: _ctx.directT('settings.leadsSettings.statusManagement.statusNamePlaceholder')
                  }, null, 8, _hoisted_96), [
                    [_vModelText, _ctx.editingStatus.name]
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_97, _toDisplayString(_ctx.directT('settings.leadsSettings.statusManagement.statusColor')), 1),
                  _createElementVNode("div", _hoisted_98, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editingStatus.color) = $event)),
                      type: "color",
                      class: "w-16 h-12 rounded-lg border-2 border-gray-200 focus:ring-2 focus:ring-green-100 focus:border-green-500 transition-all duration-300"
                    }, null, 512), [
                      [_vModelText, _ctx.editingStatus.color]
                    ]),
                    _createElementVNode("div", _hoisted_99, [
                      _createElementVNode("div", _hoisted_100, [
                        _createElementVNode("div", {
                          class: "w-6 h-6 rounded-full border-2 border-white shadow-sm",
                          style: _normalizeStyle({ backgroundColor: _ctx.editingStatus.color })
                        }, null, 4),
                        _createElementVNode("div", null, [
                          _createElementVNode("p", _hoisted_101, _toDisplayString(_ctx.editingStatus.name || 'Status Preview'), 1),
                          _createElementVNode("p", _hoisted_102, _toDisplayString(_ctx.editingStatus.color), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_103, [
              _cache[78] || (_cache[78] = _createElementVNode("div", { class: "text-xs text-gray-500" }, [
                _createElementVNode("span", { class: "font-medium" }, "Tip:"),
                _createTextVNode(" Choose a distinctive color for easy identification ")
              ], -1)),
              _createElementVNode("div", _hoisted_104, [
                _createElementVNode("button", {
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.closeStatusModal && _ctx.closeStatusModal(...args))),
                  class: "px-4 py-2 text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 text-sm font-medium"
                }, _toDisplayString(_ctx.directT('settings.leadsSettings.cancel')), 1),
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.saveStatus && _ctx.saveStatus(...args))),
                  disabled: !_ctx.editingStatus.name.trim(),
                  class: "px-6 py-2 text-white rounded-lg hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 text-sm font-medium shadow-md disabled:shadow-none",
                  style: {"background":"linear-gradient(135deg, #10B981 0%, #059669 50%, #047857 100%)"}
                }, _toDisplayString(_ctx.directT('settings.leadsSettings.save')), 9, _hoisted_105)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSourceModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/30 backdrop-blur-md",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.closeSourceModal && _ctx.closeSourceModal(...args)))
          }),
          _createElementVNode("div", _hoisted_107, [
            _createElementVNode("div", _hoisted_108, [
              _createElementVNode("div", _hoisted_109, [
                _createElementVNode("div", _hoisted_110, [
                  _cache[79] || (_cache[79] = _createElementVNode("div", { class: "w-8 h-8 bg-white/30 rounded-lg flex items-center justify-center border border-white/20" }, [
                    _createElementVNode("svg", {
                      class: "w-4 h-4 text-white",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_111, _toDisplayString(_ctx.editingSourceIndex === -1 ? _ctx.directT('settings.leadsSettings.sourceManagement.addSourceTitle') : _ctx.directT('settings.leadsSettings.sourceManagement.editSourceTitle')), 1),
                    _createElementVNode("p", _hoisted_112, _toDisplayString(_ctx.editingSourceIndex === -1 ? 'Create a new lead source' : 'Update lead source settings'), 1)
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.closeSourceModal && _ctx.closeSourceModal(...args))),
                  class: "w-8 h-8 bg-white/30 hover:bg-white/40 rounded-lg flex items-center justify-center transition-all duration-200 border border-white/20"
                }, _cache[80] || (_cache[80] = [
                  _createElementVNode("svg", {
                    class: "w-4 h-4 text-white",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_113, [
              _cache[84] || (_cache[84] = _createStaticVNode("<div class=\"text-center\" data-v-0124dbfa><div class=\"w-16 h-16 bg-gradient-to-br from-blue-100 to-sky-100 rounded-xl flex items-center justify-center mx-auto mb-4 shadow-md\" data-v-0124dbfa><svg class=\"w-8 h-8 text-blue-600\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-0124dbfa><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1\" data-v-0124dbfa></path></svg></div><h4 class=\"text-lg font-semibold text-gray-900 mb-2\" data-v-0124dbfa>Lead Source Configuration</h4><p class=\"text-gray-600 text-sm\" data-v-0124dbfa>Configure the source name for tracking where your leads come from</p></div>", 1)),
              _createElementVNode("form", {
                onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveSource && _ctx.saveSource(...args)), ["prevent"])),
                class: "space-y-4"
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_114, _toDisplayString(_ctx.directT('settings.leadsSettings.sourceManagement.sourceName')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.editingSource.name) = $event)),
                    required: "",
                    class: "w-full px-3 py-2.5 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-100 focus:border-blue-500 bg-gray-50 text-gray-900 transition-all duration-300 placeholder:text-gray-400",
                    placeholder: _ctx.directT('settings.leadsSettings.sourceManagement.sourceNamePlaceholder')
                  }, null, 8, _hoisted_115), [
                    [_vModelText, _ctx.editingSource.name]
                  ])
                ]),
                _createElementVNode("div", _hoisted_116, [
                  _createElementVNode("div", _hoisted_117, [
                    _cache[82] || (_cache[82] = _createElementVNode("div", { class: "w-6 h-6 bg-blue-100 rounded flex items-center justify-center" }, [
                      _createElementVNode("svg", {
                        class: "w-3 h-3 text-blue-600",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                        })
                      ])
                    ], -1)),
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_118, _toDisplayString(_ctx.editingSource.name || 'Source Preview'), 1),
                      _cache[81] || (_cache[81] = _createElementVNode("p", { class: "text-xs text-gray-500" }, "Lead Source", -1))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_119, [
                  _cache[83] || (_cache[83] = _createElementVNode("div", { class: "text-xs text-gray-500" }, [
                    _createElementVNode("span", { class: "font-medium" }, "Tip:"),
                    _createTextVNode(" Use descriptive names like \"Website\", \"Social Media\", etc. ")
                  ], -1)),
                  _createElementVNode("div", _hoisted_120, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.closeSourceModal && _ctx.closeSourceModal(...args))),
                      class: "px-4 py-2 text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 text-sm font-medium"
                    }, _toDisplayString(_ctx.directT('settings.leadsSettings.cancel')), 1),
                    _createElementVNode("button", {
                      type: "submit",
                      disabled: !_ctx.editingSource.name.trim(),
                      class: "px-6 py-2 text-white rounded-lg hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 text-sm font-medium shadow-md disabled:shadow-none",
                      style: {"background":"linear-gradient(135deg, #3B82F6 0%, #2563EB 50%, #1D4ED8 100%)"}
                    }, _toDisplayString(_ctx.directT('settings.leadsSettings.save')), 9, _hoisted_121)
                  ])
                ])
              ], 32)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showDeleteModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/30 backdrop-blur-md",
            onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args)))
          }),
          _createElementVNode("div", _hoisted_123, [
            _createElementVNode("div", _hoisted_124, [
              _createElementVNode("div", _hoisted_125, [
                _createElementVNode("div", _hoisted_126, [
                  _cache[86] || (_cache[86] = _createElementVNode("div", { class: "w-8 h-8 bg-white/30 rounded-lg flex items-center justify-center border border-white/20" }, [
                    _createElementVNode("svg", {
                      class: "w-4 h-4 text-white",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_127, _toDisplayString(_ctx.directT('settings.leadsSettings.confirmDeletion')), 1),
                    _cache[85] || (_cache[85] = _createElementVNode("p", { class: "text-white/90 text-sm" }, "This action cannot be undone", -1))
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args))),
                  class: "w-8 h-8 bg-white/30 hover:bg-white/40 rounded-lg flex items-center justify-center transition-all duration-200 border border-white/20"
                }, _cache[87] || (_cache[87] = [
                  _createElementVNode("svg", {
                    class: "w-4 h-4 text-white",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_128, [
              _createElementVNode("div", _hoisted_129, [
                _cache[88] || (_cache[88] = _createElementVNode("div", { class: "w-16 h-16 bg-gradient-to-br from-red-100 to-rose-100 rounded-xl flex items-center justify-center mx-auto mb-4 shadow-md" }, [
                  _createElementVNode("svg", {
                    class: "w-8 h-8 text-red-600",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                    })
                  ])
                ], -1)),
                _createElementVNode("h4", _hoisted_130, "Delete " + _toDisplayString(_ctx.deleteType === 'status' ? 'Status' : 'Source'), 1),
                _createElementVNode("p", _hoisted_131, _toDisplayString(_ctx.deleteType === 'status' ? _ctx.directT('settings.leadsSettings.statusManagement.deleteConfirmation') : _ctx.directT('settings.leadsSettings.sourceManagement.deleteConfirmation')), 1)
              ]),
              _createElementVNode("div", _hoisted_132, [
                _createElementVNode("div", _hoisted_133, [
                  _cache[90] || (_cache[90] = _createElementVNode("div", { class: "w-6 h-6 bg-red-100 rounded-lg flex items-center justify-center mt-0.5 flex-shrink-0" }, [
                    _createElementVNode("svg", {
                      class: "w-4 h-4 text-red-600",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.732-.833-2.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_134, [
                    _cache[89] || (_cache[89] = _createElementVNode("p", { class: "font-semibold text-sm mb-1" }, "Warning", -1)),
                    _createElementVNode("p", _hoisted_135, "This will permanently remove the " + _toDisplayString(_ctx.deleteType) + " from your system. Any leads with this " + _toDisplayString(_ctx.deleteType) + " will need to be reassigned.", 1)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_136, [
              _cache[91] || (_cache[91] = _createElementVNode("div", { class: "text-xs text-gray-500" }, [
                _createElementVNode("span", { class: "font-medium" }, "Note:"),
                _createTextVNode(" This action is permanent and cannot be reversed ")
              ], -1)),
              _createElementVNode("div", _hoisted_137, [
                _createElementVNode("button", {
                  onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args))),
                  class: "px-4 py-2 text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 text-sm font-medium"
                }, _toDisplayString(_ctx.directT('settings.leadsSettings.cancel')), 1),
                _createElementVNode("button", {
                  onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args))),
                  class: "px-6 py-2 text-white rounded-lg hover:shadow-lg transition-all duration-200 text-sm font-medium shadow-md",
                  style: {"background":"linear-gradient(135deg, #DC2626 0%, #B91C1C 50%, #991B1B 100%)"}
                }, _toDisplayString(_ctx.directT('settings.leadsSettings.delete')), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isAddingCard)
      ? (_openBlock(), _createElementBlock("div", _hoisted_138, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/30 backdrop-blur-md",
            onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.cancelCardCreation && _ctx.cancelCardCreation(...args)))
          }),
          _createElementVNode("div", _hoisted_139, [
            (_ctx.currentStep === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                  _createElementVNode("div", _hoisted_141, [
                    _createElementVNode("div", _hoisted_142, [
                      _createElementVNode("div", _hoisted_143, [
                        _cache[92] || (_cache[92] = _createElementVNode("div", { class: "w-8 h-8 bg-white/30 rounded-lg flex items-center justify-center border border-white/20" }, [
                          _createElementVNode("svg", {
                            class: "w-4 h-4 text-white",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                            })
                          ])
                        ], -1)),
                        _createElementVNode("div", null, [
                          _createElementVNode("h3", _hoisted_144, _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.title')), 1),
                          _createElementVNode("p", _hoisted_145, _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.step1Of2')), 1)
                        ])
                      ]),
                      _createElementVNode("button", {
                        onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.cancelCardCreation && _ctx.cancelCardCreation(...args))),
                        class: "w-8 h-8 bg-white/30 hover:bg-white/40 rounded-lg flex items-center justify-center transition-all duration-200 border border-white/20"
                      }, _cache[93] || (_cache[93] = [
                        _createElementVNode("svg", {
                          class: "w-4 h-4 text-white",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M6 18L18 6M6 6l12 12"
                          })
                        ], -1)
                      ]))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_146, [
                    _createElementVNode("div", _hoisted_147, [
                      _createElementVNode("div", _hoisted_148, [
                        _cache[94] || (_cache[94] = _createElementVNode("div", { class: "w-16 h-16 bg-gradient-to-br from-green-100 to-emerald-100 rounded-xl flex items-center justify-center mx-auto mb-3 shadow-md" }, [
                          _createElementVNode("svg", {
                            class: "w-8 h-8 text-green-600",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                            })
                          ])
                        ], -1)),
                        _createElementVNode("h4", _hoisted_149, _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.cardInformation')), 1),
                        _createElementVNode("p", _hoisted_150, _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.cardInformationDescription')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_151, [
                        _createElementVNode("div", null, [
                          _createElementVNode("label", _hoisted_152, _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.cardName')), 1),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.editingArea.title) = $event)),
                            type: "text",
                            placeholder: _ctx.directT('settings.leadsSettings.cardCreation.cardNamePlaceholder'),
                            class: "w-full px-3 py-2.5 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-green-100 focus:border-green-500 bg-gray-50 text-gray-900 transition-all duration-300 placeholder:text-gray-400"
                          }, null, 8, _hoisted_153), [
                            [_vModelText, _ctx.editingArea.title]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_154, [
                          _createElementVNode("div", _hoisted_155, [
                            _cache[95] || (_cache[95] = _createElementVNode("div", { class: "w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center" }, [
                              _createElementVNode("svg", {
                                class: "w-4 h-4 text-white",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                                })
                              ])
                            ], -1)),
                            _createElementVNode("div", null, [
                              _createElementVNode("h5", _hoisted_156, _toDisplayString(_ctx.editingArea.title || _ctx.directT('settings.leadsSettings.cardCreation.cardNamePreview')), 1),
                              _createElementVNode("p", _hoisted_157, _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.customCard')), 1)
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_158, _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.previewDescription')), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_159, [
                    _createElementVNode("div", _hoisted_160, _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.nextStep')), 1),
                    _createElementVNode("div", _hoisted_161, [
                      _createElementVNode("button", {
                        onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.cancelCardCreation && _ctx.cancelCardCreation(...args))),
                        class: "px-4 py-2 text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 text-sm font-medium"
                      }, _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.cancel')), 1),
                      _createElementVNode("button", {
                        onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.proceedToFieldSelection && _ctx.proceedToFieldSelection(...args))),
                        disabled: !_ctx.editingArea.title.trim(),
                        class: "px-6 py-2 text-white rounded-lg hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 text-sm font-medium shadow-md disabled:shadow-none",
                        style: {"background":"linear-gradient(135deg, #10B981 0%, #059669 50%, #047857 100%)"}
                      }, _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.continue')), 9, _hoisted_162)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.currentStep === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                  _createElementVNode("div", _hoisted_164, [
                    _createElementVNode("div", _hoisted_165, [
                      _createElementVNode("div", _hoisted_166, [
                        _cache[96] || (_cache[96] = _createElementVNode("div", { class: "w-6 h-6 bg-white/30 rounded flex items-center justify-center border border-white/20" }, [
                          _createElementVNode("svg", {
                            class: "w-3 h-3 text-white",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                            })
                          ])
                        ], -1)),
                        _createElementVNode("h4", _hoisted_167, _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.addFields')), 1)
                      ]),
                      _createElementVNode("p", _hoisted_168, _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.addFieldsDescription')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_169, [
                      _createElementVNode("div", _hoisted_170, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldTypes, (fieldType) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: fieldType.type,
                            onClick: ($event: any) => (_ctx.selectFieldType(fieldType.type)),
                            class: "group p-3 text-left bg-white border border-gray-200 rounded-lg hover:border-blue-300 hover:shadow-sm transition-all duration-200"
                          }, [
                            _createElementVNode("div", _hoisted_172, [
                              _createElementVNode("div", _hoisted_173, [
                                (_openBlock(), _createElementBlock("svg", _hoisted_174, [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2",
                                    d: _ctx.getFieldIcon(fieldType.type)
                                  }, null, 8, _hoisted_175)
                                ]))
                              ]),
                              _createElementVNode("div", null, [
                                _createElementVNode("span", _hoisted_176, _toDisplayString(fieldType.name), 1),
                                _createElementVNode("p", _hoisted_177, _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.addThisFieldType')), 1)
                              ])
                            ])
                          ], 8, _hoisted_171))
                        }), 128))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_178, [
                    _createElementVNode("div", _hoisted_179, [
                      _createElementVNode("div", _hoisted_180, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_181, [
                            _cache[97] || (_cache[97] = _createElementVNode("div", { class: "w-6 h-6 bg-white/30 rounded flex items-center justify-center border border-white/20" }, [
                              _createElementVNode("svg", {
                                class: "w-3 h-3 text-white",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                                })
                              ])
                            ], -1)),
                            _createElementVNode("h4", _hoisted_182, _toDisplayString(_ctx.editingArea.title), 1)
                          ]),
                          _createElementVNode("p", _hoisted_183, _toDisplayString(_ctx.editingArea.fields.length) + " " + _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.fieldsConfigured')), 1)
                        ]),
                        _createElementVNode("button", {
                          onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.finishCardCreation && _ctx.finishCardCreation(...args))),
                          disabled: _ctx.editingArea.fields.length === 0,
                          class: "px-3 py-1.5 text-xs font-medium text-green-600 bg-white rounded hover:bg-green-50 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 shadow-sm disabled:shadow-none"
                        }, _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.saveCard')), 9, _hoisted_184)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_185, [
                      (_ctx.editingArea.fields.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
                            _cache[98] || (_cache[98] = _createElementVNode("div", { class: "w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center mx-auto mb-3" }, [
                              _createElementVNode("svg", {
                                class: "w-6 h-6 text-gray-400",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                                })
                              ])
                            ], -1)),
                            _createElementVNode("h5", _hoisted_187, _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.noFieldsYet')), 1),
                            _createElementVNode("p", _hoisted_188, _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.chooseFieldTypes')), 1)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_189, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editingArea.fields, (field, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: field.id || index,
                                class: "group p-3 bg-gray-50 border border-gray-200 rounded-lg hover:border-gray-300 hover:shadow-sm transition-all duration-200"
                              }, [
                                _createElementVNode("div", _hoisted_190, [
                                  _createElementVNode("div", _hoisted_191, [
                                    _createElementVNode("div", _hoisted_192, [
                                      _cache[100] || (_cache[100] = _createElementVNode("div", { class: "w-6 h-6 bg-green-100 rounded flex items-center justify-center" }, [
                                        _createElementVNode("svg", {
                                          class: "w-3 h-3 text-green-600",
                                          fill: "none",
                                          stroke: "currentColor",
                                          viewBox: "0 0 24 24"
                                        }, [
                                          _createElementVNode("path", {
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round",
                                            "stroke-width": "2",
                                            d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                                          })
                                        ])
                                      ], -1)),
                                      _createElementVNode("div", _hoisted_193, [
                                        _createElementVNode("div", _hoisted_194, [
                                          _createElementVNode("span", _hoisted_195, _toDisplayString(field.label), 1),
                                          (field.required)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_196, _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.required')), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_197, [
                                          _createElementVNode("span", _hoisted_198, _toDisplayString(_ctx.getFieldTypeLabel(field.type)), 1),
                                          _cache[99] || (_cache[99] = _createElementVNode("span", { class: "text-gray-400" }, "•", -1)),
                                          _createElementVNode("span", _hoisted_199, _toDisplayString(field.placeholder), 1)
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_200, [
                                    _createElementVNode("button", {
                                      onClick: ($event: any) => (_ctx.editFieldInCard(index)),
                                      class: "w-6 h-6 bg-blue-100 hover:bg-blue-200 text-blue-600 rounded flex items-center justify-center transition-all duration-200"
                                    }, _cache[101] || (_cache[101] = [
                                      _createElementVNode("svg", {
                                        class: "w-3 h-3",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                                        })
                                      ], -1)
                                    ]), 8, _hoisted_201),
                                    _createElementVNode("button", {
                                      onClick: ($event: any) => (_ctx.removeFieldFromCard(field.id)),
                                      class: "w-6 h-6 bg-red-100 hover:bg-red-200 text-red-600 rounded flex items-center justify-center transition-all duration-200"
                                    }, _cache[102] || (_cache[102] = [
                                      _createElementVNode("svg", {
                                        class: "w-3 h-3",
                                        fill: "none",
                                        stroke: "currentColor",
                                        viewBox: "0 0 24 24"
                                      }, [
                                        _createElementVNode("path", {
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                          "stroke-width": "2",
                                          d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                        })
                                      ], -1)
                                    ]), 8, _hoisted_202)
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                    ]),
                    _createElementVNode("div", _hoisted_203, [
                      _createElementVNode("button", {
                        onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.currentStep = 1)),
                        class: "flex items-center gap-1 px-3 py-1.5 text-gray-600 hover:text-gray-800 transition-colors duration-200 text-sm"
                      }, [
                        _cache[103] || (_cache[103] = _createElementVNode("svg", {
                          class: "w-3 h-3",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M10 19l-7-7m0 0l7-7m-7 7h18"
                          })
                        ], -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.backToCardInfo')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_204, [
                        _createElementVNode("span", _hoisted_205, _toDisplayString(_ctx.editingArea.fields.length), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.fieldsConfigured')), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showFieldTypeModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_206, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/20 backdrop-blur-sm",
            onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.cancelCardCreation && _ctx.cancelCardCreation(...args)))
          }),
          _createElementVNode("div", _hoisted_207, [
            _createElementVNode("div", _hoisted_208, [
              _createElementVNode("div", _hoisted_209, [
                _createElementVNode("div", null, [
                  _createElementVNode("h3", _hoisted_210, "Building Card: " + _toDisplayString(_ctx.editingArea.title), 1),
                  _cache[104] || (_cache[104] = _createElementVNode("p", { class: "text-xs text-slate-500 dark:text-slate-400 mt-0.5" }, "Add fields to your custom card", -1))
                ]),
                _createElementVNode("button", {
                  onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.cancelCardCreation && _ctx.cancelCardCreation(...args))),
                  class: "p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors"
                }, _cache[105] || (_cache[105] = [
                  _createElementVNode("svg", {
                    class: "w-4 h-4",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_211, [
              _createElementVNode("div", _hoisted_212, [
                _cache[106] || (_cache[106] = _createElementVNode("h4", { class: "text-sm font-medium text-slate-900 dark:text-white mb-3" }, "Choose Field Type", -1)),
                _createElementVNode("div", _hoisted_213, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fieldTypes, (fieldType) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: fieldType.type,
                      onClick: ($event: any) => (_ctx.selectFieldType(fieldType.type)),
                      class: "group relative p-3 bg-slate-50 dark:bg-slate-700/50 rounded-lg border border-slate-200 dark:border-slate-600 hover:border-slate-400 dark:hover:border-slate-500 cursor-pointer transition-all duration-200 hover:shadow-sm"
                    }, [
                      _createElementVNode("div", {
                        class: "flex items-center justify-center w-8 h-8 rounded-lg shadow-sm mb-2 group-hover:scale-105 transition-all duration-200",
                        style: _normalizeStyle({ background: _ctx.getFieldTypeIconColors(fieldType.type).background })
                      }, [
                        (_openBlock(), _createElementBlock("svg", {
                          class: "w-4 h-4",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24",
                          style: _normalizeStyle({ color: _ctx.getFieldTypeIconColors(fieldType.type).icon })
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "1.5",
                            d: _ctx.getFieldIcon(fieldType.type)
                          }, null, 8, _hoisted_215)
                        ], 4))
                      ], 4),
                      _createElementVNode("div", null, [
                        _createElementVNode("h5", _hoisted_216, _toDisplayString(fieldType.name), 1),
                        _createElementVNode("p", _hoisted_217, _toDisplayString(fieldType.description), 1)
                      ])
                    ], 8, _hoisted_214))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_218, [
                _createElementVNode("div", _hoisted_219, [
                  _cache[107] || (_cache[107] = _createElementVNode("h4", { class: "text-sm font-medium text-slate-900 dark:text-white" }, "Card Preview", -1)),
                  _createElementVNode("span", _hoisted_220, _toDisplayString(_ctx.editingArea.fields.length) + " fields", 1)
                ]),
                _createElementVNode("div", _hoisted_221, [
                  _createElementVNode("div", _hoisted_222, [
                    _cache[108] || (_cache[108] = _createElementVNode("div", { class: "w-5 h-5 rounded bg-slate-100 dark:bg-slate-700 flex items-center justify-center" }, [
                      _createElementVNode("svg", {
                        class: "w-3 h-3 text-slate-600 dark:text-slate-400",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                        })
                      ])
                    ], -1)),
                    _createElementVNode("h5", _hoisted_223, _toDisplayString(_ctx.editingArea.title), 1)
                  ]),
                  (_ctx.editingArea.fields.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_224, _cache[109] || (_cache[109] = [
                        _createElementVNode("div", { class: "w-8 h-8 bg-slate-100 dark:bg-slate-700 rounded-lg flex items-center justify-center mx-auto mb-2" }, [
                          _createElementVNode("svg", {
                            class: "w-4 h-4 text-slate-400",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                            })
                          ])
                        ], -1),
                        _createElementVNode("p", { class: "text-xs text-slate-500 dark:text-slate-400" }, "No fields added yet", -1)
                      ])))
                    : (_openBlock(), _createElementBlock("div", _hoisted_225, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editingArea.fields, (field) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: field.id,
                            class: "flex items-center gap-2 p-2 bg-slate-50 dark:bg-slate-700/50 rounded border border-slate-200 dark:border-slate-600"
                          }, [
                            _createElementVNode("div", {
                              class: "w-4 h-4 rounded flex items-center justify-center",
                              style: _normalizeStyle({ background: _ctx.getFieldTypeIconColors(field.type).background })
                            }, [
                              (_openBlock(), _createElementBlock("svg", {
                                class: "w-2.5 h-2.5",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24",
                                style: _normalizeStyle({ color: _ctx.getFieldTypeIconColors(field.type).icon })
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: _ctx.getFieldIcon(field.type)
                                }, null, 8, _hoisted_226)
                              ], 4))
                            ], 4),
                            _createElementVNode("div", _hoisted_227, [
                              _createElementVNode("p", _hoisted_228, _toDisplayString(field.label), 1),
                              _createElementVNode("p", _hoisted_229, _toDisplayString(_ctx.getFieldTypeLabel(field.type)), 1)
                            ]),
                            _createElementVNode("button", {
                              onClick: ($event: any) => (_ctx.removeFieldFromCard(field.id)),
                              class: "p-0.5 text-slate-400 hover:text-red-500 rounded transition-colors"
                            }, _cache[110] || (_cache[110] = [
                              _createElementVNode("svg", {
                                class: "w-3 h-3",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M6 18L18 6M6 6l12 12"
                                })
                              ], -1)
                            ]), 8, _hoisted_230)
                          ]))
                        }), 128))
                      ]))
                ]),
                _createElementVNode("button", {
                  onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.finishCardCreation && _ctx.finishCardCreation(...args))),
                  class: _normalizeClass(["w-full px-3 py-2 text-white rounded text-sm font-medium transition-all duration-200 flex items-center justify-center gap-2 hover:shadow-md", _ctx.editingArea.fields.length === 0 ? 'opacity-50 cursor-not-allowed' : 'hover:scale-105']),
                  style: {"background":"linear-gradient(135deg, #10B981, #059669)"},
                  disabled: _ctx.editingArea.fields.length === 0
                }, [
                  _cache[111] || (_cache[111] = _createElementVNode("svg", {
                    class: "w-4 h-4",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M5 13l4 4L19 7"
                    })
                  ], -1)),
                  _createTextVNode(" Finish Card (" + _toDisplayString(_ctx.editingArea.fields.length) + " fields) ", 1)
                ], 10, _hoisted_231)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showFieldDetailsModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_232, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/20 backdrop-blur-sm",
            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.showFieldDetailsModal = false))
          }),
          _createElementVNode("div", _hoisted_233, [
            _createElementVNode("div", _hoisted_234, [
              _cache[115] || (_cache[115] = _createElementVNode("div", { class: "absolute inset-0 bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 dark:from-slate-900 dark:via-blue-900/20 dark:to-indigo-900/20" }, null, -1)),
              _createElementVNode("div", _hoisted_235, [
                _createElementVNode("div", _hoisted_236, [
                  _createElementVNode("div", _hoisted_237, [
                    _createElementVNode("button", {
                      onClick: _cache[29] || (_cache[29] = () => { _ctx.showFieldDetailsModal = false; _ctx.showFieldTypeModal = true; }),
                      class: "p-1.5 text-slate-500 hover:text-slate-700 hover:bg-white/80 dark:hover:bg-slate-800/80 rounded-lg transition-all duration-200"
                    }, _cache[112] || (_cache[112] = [
                      _createElementVNode("svg", {
                        class: "w-4 h-4",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M15 19l-7-7 7-7"
                        })
                      ], -1)
                    ])),
                    _createElementVNode("div", {
                      class: "w-8 h-8 rounded-lg shadow-sm flex items-center justify-center",
                      style: _normalizeStyle({ background: _ctx.getFieldTypeIconColors(_ctx.editingField.type).background })
                    }, [
                      (_openBlock(), _createElementBlock("svg", {
                        class: "w-4 h-4",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        style: _normalizeStyle({ color: _ctx.getFieldTypeIconColors(_ctx.editingField.type).icon })
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: _ctx.getFieldIcon(_ctx.editingField.type)
                        }, null, 8, _hoisted_238)
                      ], 4))
                    ], 4),
                    _createElementVNode("div", null, [
                      _createElementVNode("h3", _hoisted_239, _toDisplayString(_ctx.getFieldTypeLabel(_ctx.editingField.type)) + " Field", 1),
                      _cache[113] || (_cache[113] = _createElementVNode("p", { class: "text-xs text-slate-500 dark:text-slate-400" }, "Configure field settings", -1))
                    ])
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.showFieldDetailsModal = false)),
                    class: "p-1.5 text-slate-400 hover:text-slate-600 hover:bg-white/80 dark:hover:bg-slate-800/80 rounded-lg transition-all duration-200"
                  }, _cache[114] || (_cache[114] = [
                    _createElementVNode("svg", {
                      class: "w-4 h-4",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M6 18L18 6M6 6l12 12"
                      })
                    ], -1)
                  ]))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_240, [
              _createElementVNode("form", {
                onSubmit: _cache[44] || (_cache[44] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveFieldDetails && _ctx.saveFieldDetails(...args)), ["prevent"])),
                class: "space-y-4"
              }, [
                _createElementVNode("div", _hoisted_241, [
                  _cache[116] || (_cache[116] = _createElementVNode("label", { class: "block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2" }, [
                    _createElementVNode("span", { class: "text-rose-500" }, "*"),
                    _createTextVNode(" Field Label ")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.editingField.label) = $event)),
                    required: "",
                    class: "w-full px-3 py-2.5 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-slate-900 dark:text-white transition-all duration-200 placeholder:text-slate-400",
                    placeholder: _ctx.getFieldLabelPlaceholder(_ctx.editingField.type)
                  }, null, 8, _hoisted_242), [
                    [_vModelText, _ctx.editingField.label]
                  ])
                ]),
                _createElementVNode("div", _hoisted_243, [
                  _createElementVNode("div", _hoisted_244, [
                    _cache[117] || (_cache[117] = _createElementVNode("div", null, [
                      _createElementVNode("h4", { class: "text-sm font-medium text-slate-700 dark:text-slate-300" }, "Required Field"),
                      _createElementVNode("p", { class: "text-xs text-slate-500 dark:text-slate-400" }, "Users must fill this field")
                    ], -1)),
                    _createElementVNode("div", _hoisted_245, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: "fieldRequired",
                        "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.editingField.required) = $event)),
                        class: "sr-only"
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.editingField.required]
                      ]),
                      _createElementVNode("label", _hoisted_246, [
                        _createElementVNode("div", _hoisted_247, [
                          _createElementVNode("div", {
                            class: "w-10 h-5 rounded-full shadow-inner transition-colors duration-200",
                            style: _normalizeStyle({ backgroundColor: _ctx.editingField.required ? '#EF4444' : '#E2E8F0' })
                          }, null, 4),
                          _createElementVNode("div", {
                            class: _normalizeClass(["absolute left-0.5 top-0.5 bg-white w-4 h-4 rounded-full transition-transform duration-200 shadow", _ctx.editingField.required ? 'transform translate-x-5' : ''])
                          }, null, 2)
                        ])
                      ])
                    ])
                  ])
                ]),
                (_ctx.editingField.type === 'text')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_248, [
                      _cache[120] || (_cache[120] = _createStaticVNode("<div class=\"flex items-center gap-3 mb-3\" data-v-0124dbfa><div class=\"w-6 h-6 rounded-lg bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center\" data-v-0124dbfa><svg class=\"w-3 h-3 text-blue-600 dark:text-blue-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-0124dbfa><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M4 6h16M4 12h16m-7 6h7\" data-v-0124dbfa></path></svg></div><div data-v-0124dbfa><h4 class=\"text-sm font-semibold text-slate-900 dark:text-white\" data-v-0124dbfa>Text Input Settings</h4><p class=\"text-xs text-slate-600 dark:text-slate-400\" data-v-0124dbfa>Configure text input behavior</p></div></div>", 1)),
                      _createElementVNode("div", _hoisted_249, [
                        _createElementVNode("div", null, [
                          _cache[118] || (_cache[118] = _createElementVNode("label", { class: "block text-xs font-medium text-slate-700 dark:text-slate-300 mb-1" }, "Placeholder Text", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.editingField.placeholder) = $event)),
                            class: "w-full px-3 py-2 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg focus:ring-2 focus:ring-blue-500 text-slate-900 dark:text-white transition-all text-sm",
                            placeholder: "e.g., Enter your full name"
                          }, null, 512), [
                            [_vModelText, _ctx.editingField.placeholder]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[119] || (_cache[119] = _createElementVNode("label", { class: "block text-xs font-medium text-slate-700 dark:text-slate-300 mb-1" }, "Max Length", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.editingField.maxLength) = $event)),
                            class: "w-full px-3 py-2 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg focus:ring-2 focus:ring-blue-500 text-slate-900 dark:text-white transition-all text-sm",
                            placeholder: "100",
                            min: "1"
                          }, null, 512), [
                            [_vModelText, _ctx.editingField.maxLength]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.editingField.type === 'number')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_250, [
                      _cache[124] || (_cache[124] = _createStaticVNode("<div class=\"flex items-start gap-4 mb-4\" data-v-0124dbfa><div class=\"w-10 h-10 rounded-xl bg-purple-100 dark:bg-purple-900/30 flex items-center justify-center\" data-v-0124dbfa><svg class=\"w-5 h-5 text-purple-600 dark:text-purple-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-0124dbfa><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M7 20l4-16m2 16l4-16M6 9h14M4 15h14\" data-v-0124dbfa></path></svg></div><div data-v-0124dbfa><h4 class=\"text-lg font-bold text-slate-900 dark:text-white\" data-v-0124dbfa>Number Input Settings</h4><p class=\"text-sm text-slate-600 dark:text-slate-400\" data-v-0124dbfa>Configure numeric input validation and limits</p></div></div>", 1)),
                      _createElementVNode("div", _hoisted_251, [
                        _createElementVNode("div", null, [
                          _cache[121] || (_cache[121] = _createElementVNode("label", { class: "block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2" }, "Minimum Value", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.editingField.min) = $event)),
                            class: "w-full px-3 py-2.5 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg focus:ring-2 focus:ring-purple-500 text-slate-900 dark:text-white transition-all",
                            placeholder: "0"
                          }, null, 512), [
                            [_vModelText, _ctx.editingField.min]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[122] || (_cache[122] = _createElementVNode("label", { class: "block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2" }, "Maximum Value", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.editingField.max) = $event)),
                            class: "w-full px-3 py-2.5 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg focus:ring-2 focus:ring-purple-500 text-slate-900 dark:text-white transition-all",
                            placeholder: "999"
                          }, null, 512), [
                            [_vModelText, _ctx.editingField.max]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[123] || (_cache[123] = _createElementVNode("label", { class: "block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2" }, "Step", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.editingField.step) = $event)),
                            class: "w-full px-3 py-2.5 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg focus:ring-2 focus:ring-purple-500 text-slate-900 dark:text-white transition-all",
                            placeholder: "1",
                            min: "0.01",
                            step: "0.01"
                          }, null, 512), [
                            [_vModelText, _ctx.editingField.step]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.editingField.type === 'select' || _ctx.editingField.type === 'multiselect')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_252, [
                      _createElementVNode("div", _hoisted_253, [
                        _cache[125] || (_cache[125] = _createElementVNode("div", { class: "w-10 h-10 rounded-xl bg-orange-100 dark:bg-orange-900/30 flex items-center justify-center" }, [
                          _createElementVNode("svg", {
                            class: "w-5 h-5 text-orange-600 dark:text-orange-400",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M19 9l-7 7-7-7"
                            })
                          ])
                        ], -1)),
                        _createElementVNode("div", null, [
                          _createElementVNode("h4", _hoisted_254, _toDisplayString(_ctx.editingField.type === 'select' ? 'Dropdown' : 'Multi-Select') + " Options ", 1),
                          _createElementVNode("p", _hoisted_255, _toDisplayString(_ctx.editingField.type === 'select' ? 'Users can select one option' : 'Users can select multiple options'), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_256, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editingField.options, (option, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "flex items-center gap-3 group"
                          }, [
                            _createElementVNode("div", _hoisted_257, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                "onUpdate:modelValue": ($event: any) => ((_ctx.editingField.options![index]) = $event),
                                class: "w-full px-4 py-3 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-slate-900 dark:text-white transition-all placeholder:text-slate-400",
                                placeholder: `Option ${index + 1}`
                              }, null, 8, _hoisted_258), [
                                [_vModelText, _ctx.editingField.options![index]]
                              ])
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              onClick: ($event: any) => (_ctx.removeFieldOption(index)),
                              class: "p-2.5 text-rose-500 hover:text-rose-700 hover:bg-rose-50 dark:hover:bg-rose-900/20 rounded-xl transition-all opacity-0 group-hover:opacity-100",
                              disabled: _ctx.editingField.options?.length === 1
                            }, _cache[126] || (_cache[126] = [
                              _createElementVNode("svg", {
                                class: "w-5 h-5",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                })
                              ], -1)
                            ]), 8, _hoisted_259)
                          ]))
                        }), 128))
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.addFieldOption && _ctx.addFieldOption(...args))),
                        class: "w-full px-4 py-4 bg-slate-50 dark:bg-slate-900 hover:bg-orange-50 dark:hover:bg-orange-900/20 text-orange-600 dark:text-orange-400 border-2 border-dashed border-orange-200 dark:border-orange-800 rounded-xl transition-all duration-200 flex items-center justify-center gap-2 font-medium hover:border-orange-300 dark:hover:border-orange-700"
                      }, _cache[127] || (_cache[127] = [
                        _createElementVNode("svg", {
                          class: "w-5 h-5",
                          fill: "none",
                          stroke: "currentColor",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                          })
                        ], -1),
                        _createTextVNode(" Add Option ")
                      ]))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.editingField.type === 'checkbox')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_260, [
                      _cache[129] || (_cache[129] = _createStaticVNode("<div class=\"flex items-start gap-4 mb-4\" data-v-0124dbfa><div class=\"w-10 h-10 rounded-xl bg-teal-100 dark:bg-teal-900/30 flex items-center justify-center\" data-v-0124dbfa><svg class=\"w-5 h-5 text-teal-600 dark:text-teal-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-0124dbfa><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z\" data-v-0124dbfa></path></svg></div><div data-v-0124dbfa><h4 class=\"text-lg font-bold text-slate-900 dark:text-white\" data-v-0124dbfa>Checkbox Settings</h4><p class=\"text-sm text-slate-600 dark:text-slate-400\" data-v-0124dbfa>Configure yes/no or true/false selection</p></div></div>", 1)),
                      _createElementVNode("div", null, [
                        _cache[128] || (_cache[128] = _createElementVNode("label", { class: "block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2" }, "Checkbox Label Text", -1)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.editingField.checkboxLabel) = $event)),
                          class: "w-full px-4 py-3 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-teal-500 text-slate-900 dark:text-white transition-all",
                          placeholder: "e.g., I agree to the terms and conditions"
                        }, null, 512), [
                          [_vModelText, _ctx.editingField.checkboxLabel]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.editingField.type === 'email')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_261, _cache[130] || (_cache[130] = [
                      _createStaticVNode("<div class=\"flex items-start gap-4 mb-4\" data-v-0124dbfa><div class=\"w-10 h-10 rounded-xl bg-red-100 dark:bg-red-900/30 flex items-center justify-center\" data-v-0124dbfa><svg class=\"w-5 h-5 text-red-600 dark:text-red-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-0124dbfa><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z\" data-v-0124dbfa></path></svg></div><div data-v-0124dbfa><h4 class=\"text-lg font-bold text-slate-900 dark:text-white\" data-v-0124dbfa>Email Input Settings</h4><p class=\"text-sm text-slate-600 dark:text-slate-400\" data-v-0124dbfa>Email validation and formatting options</p></div></div><div class=\"bg-blue-50 dark:bg-blue-900/20 rounded-xl p-4 border border-blue-200 dark:border-blue-800\" data-v-0124dbfa><div class=\"flex items-center gap-3\" data-v-0124dbfa><svg class=\"w-5 h-5 text-blue-600 dark:text-blue-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-0124dbfa><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z\" data-v-0124dbfa></path></svg><div class=\"text-sm text-blue-900 dark:text-blue-100\" data-v-0124dbfa><p class=\"font-semibold\" data-v-0124dbfa>Automatic Email Validation</p><p data-v-0124dbfa>This field will automatically validate email format and show error messages for invalid entries.</p></div></div></div>", 2)
                    ])))
                  : _createCommentVNode("", true),
                (_ctx.editingField.type === 'date')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_262, [
                      _cache[133] || (_cache[133] = _createStaticVNode("<div class=\"flex items-start gap-4 mb-4\" data-v-0124dbfa><div class=\"w-10 h-10 rounded-xl bg-indigo-100 dark:bg-indigo-900/30 flex items-center justify-center\" data-v-0124dbfa><svg class=\"w-5 h-5 text-indigo-600 dark:text-indigo-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-0124dbfa><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z\" data-v-0124dbfa></path></svg></div><div data-v-0124dbfa><h4 class=\"text-lg font-bold text-slate-900 dark:text-white\" data-v-0124dbfa>Date Picker Settings</h4><p class=\"text-sm text-slate-600 dark:text-slate-400\" data-v-0124dbfa>Configure date selection and limits</p></div></div>", 1)),
                      _createElementVNode("div", _hoisted_263, [
                        _createElementVNode("div", null, [
                          _cache[131] || (_cache[131] = _createElementVNode("label", { class: "block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2" }, "Minimum Date", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.editingField.minDate) = $event)),
                            class: "w-full px-3 py-2.5 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg focus:ring-2 focus:ring-indigo-500 text-slate-900 dark:text-white transition-all"
                          }, null, 512), [
                            [_vModelText, _ctx.editingField.minDate]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _cache[132] || (_cache[132] = _createElementVNode("label", { class: "block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2" }, "Maximum Date", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.editingField.maxDate) = $event)),
                            class: "w-full px-3 py-2.5 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-lg focus:ring-2 focus:ring-indigo-500 text-slate-900 dark:text-white transition-all"
                          }, null, 512), [
                            [_vModelText, _ctx.editingField.maxDate]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.editingField.type === 'file')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_264, [
                      _cache[137] || (_cache[137] = _createStaticVNode("<div class=\"flex items-start gap-4 mb-4\" data-v-0124dbfa><div class=\"w-10 h-10 rounded-xl bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center\" data-v-0124dbfa><svg class=\"w-5 h-5 text-amber-600 dark:text-amber-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-0124dbfa><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.586-6.586a2 2 0 002.828-2.828l-6.586-6.586a2 2 0 00-2.828 2.828z\" data-v-0124dbfa></path></svg></div><div data-v-0124dbfa><h4 class=\"text-lg font-bold text-slate-900 dark:text-white\" data-v-0124dbfa>File Upload Settings</h4><p class=\"text-sm text-slate-600 dark:text-slate-400\" data-v-0124dbfa>Configure file types and size limits</p></div></div>", 1)),
                      _createElementVNode("div", _hoisted_265, [
                        _createElementVNode("div", null, [
                          _cache[134] || (_cache[134] = _createElementVNode("label", { class: "block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2" }, "Allowed File Types", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.editingField.acceptedTypes) = $event)),
                            class: "w-full px-4 py-3 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-amber-500 text-slate-900 dark:text-white transition-all",
                            placeholder: "e.g., .pdf,.doc,.docx,.jpg,.png"
                          }, null, 512), [
                            [_vModelText, _ctx.editingField.acceptedTypes]
                          ]),
                          _cache[135] || (_cache[135] = _createElementVNode("p", { class: "text-xs text-slate-500 mt-1" }, "Enter file extensions separated by commas", -1))
                        ]),
                        _createElementVNode("div", null, [
                          _cache[136] || (_cache[136] = _createElementVNode("label", { class: "block text-sm font-medium text-slate-700 dark:text-slate-300 mb-2" }, "Max File Size (MB)", -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.editingField.maxFileSize) = $event)),
                            class: "w-full px-4 py-3 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl focus:ring-2 focus:ring-amber-500 text-slate-900 dark:text-white transition-all",
                            placeholder: "5",
                            min: "0.1",
                            step: "0.1"
                          }, null, 512), [
                            [_vModelText, _ctx.editingField.maxFileSize]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (['textarea', 'phone', 'url', 'datetime', 'color', 'user'].includes(_ctx.editingField.type))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_266, [
                      _createElementVNode("div", _hoisted_267, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["w-10 h-10 rounded-xl flex items-center justify-center", {
                        'bg-green-100 dark:bg-green-900/30': _ctx.editingField.type === 'textarea',
                        'bg-emerald-100 dark:bg-emerald-900/30': _ctx.editingField.type === 'phone',
                        'bg-sky-100 dark:bg-sky-900/30': _ctx.editingField.type === 'url',
                        'bg-cyan-100 dark:bg-cyan-900/30': _ctx.editingField.type === 'datetime',
                        'bg-pink-100 dark:bg-pink-900/30': _ctx.editingField.type === 'color',
                        'bg-violet-100 dark:bg-violet-900/30': _ctx.editingField.type === 'user'
                      }])
                        }, [
                          (_openBlock(), _createElementBlock("svg", {
                            class: _normalizeClass(["w-5 h-5", {
                          'text-green-600 dark:text-green-400': _ctx.editingField.type === 'textarea',
                          'text-emerald-600 dark:text-emerald-400': _ctx.editingField.type === 'phone',
                          'text-sky-600 dark:text-sky-400': _ctx.editingField.type === 'url',
                          'text-cyan-600 dark:text-cyan-400': _ctx.editingField.type === 'datetime',
                          'text-pink-600 dark:text-pink-400': _ctx.editingField.type === 'color',
                          'text-violet-600 dark:text-violet-400': _ctx.editingField.type === 'user'
                        }]),
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: _ctx.getFieldIcon(_ctx.editingField.type)
                            }, null, 8, _hoisted_268)
                          ], 2))
                        ], 2),
                        _createElementVNode("div", null, [
                          _createElementVNode("h4", _hoisted_269, _toDisplayString(_ctx.getFieldTypeLabel(_ctx.editingField.type)) + " Field", 1),
                          _createElementVNode("div", _hoisted_270, [
                            _createElementVNode("p", _hoisted_271, [
                              (_ctx.editingField.type === 'textarea')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_272, "Multi-line text area for longer content like descriptions, notes, or detailed information."))
                                : (_ctx.editingField.type === 'phone')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_273, "Phone number input with automatic formatting and validation."))
                                  : (_ctx.editingField.type === 'url')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_274, "Website URL input with link validation and formatting."))
                                    : (_ctx.editingField.type === 'datetime')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_275, "Date and time picker for scheduling and timestamps."))
                                      : (_ctx.editingField.type === 'color')
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_276, "Color picker for selecting colors with hex code output."))
                                        : (_ctx.editingField.type === 'user')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_277, "Team member selection from your organization's user list."))
                                          : _createCommentVNode("", true)
                            ]),
                            _cache[138] || (_cache[138] = _createElementVNode("div", { class: "flex items-center gap-2 text-xs text-slate-500 dark:text-slate-400" }, [
                              _createElementVNode("svg", {
                                class: "w-4 h-4",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                })
                              ]),
                              _createTextVNode(" No additional configuration required - ready to use! ")
                            ], -1))
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 32)
            ]),
            _createElementVNode("div", _hoisted_278, [
              _createElementVNode("div", _hoisted_279, [
                _createElementVNode("button", {
                  onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.showFieldDetailsModal = false)),
                  class: "px-4 py-2 bg-slate-100 hover:bg-slate-200 dark:bg-slate-700 dark:hover:bg-slate-600 text-slate-700 dark:text-slate-300 rounded-lg transition-all duration-200 text-sm font-medium"
                }, " Cancel "),
                _createElementVNode("button", {
                  onClick: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.saveFieldDetails && _ctx.saveFieldDetails(...args))),
                  class: "px-6 py-2 text-white rounded-lg transition-all duration-200 font-semibold shadow-md hover:shadow-lg flex items-center gap-2 text-sm hover:scale-105",
                  style: {"background":"linear-gradient(135deg, #3B82F6, #6366F1)"}
                }, _cache[139] || (_cache[139] = [
                  _createElementVNode("svg", {
                    class: "w-4 h-4",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
                    })
                  ], -1),
                  _createTextVNode(" Create Field ")
                ]))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showAreaModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_280, [
          _createElementVNode("div", {
            class: "fixed inset-0 bg-black/30 backdrop-blur-md",
            onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.showAreaModal = false))
          }),
          _createElementVNode("div", _hoisted_281, [
            _createElementVNode("div", _hoisted_282, [
              _createElementVNode("div", _hoisted_283, [
                _createElementVNode("div", _hoisted_284, [
                  _cache[140] || (_cache[140] = _createElementVNode("div", { class: "w-8 h-8 bg-white/30 rounded-lg flex items-center justify-center border border-white/20" }, [
                    _createElementVNode("svg", {
                      class: "w-4 h-4 text-white",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("h3", _hoisted_285, _toDisplayString(_ctx.directT('settings.leadsSettings.editCard.title')), 1),
                    _createElementVNode("p", _hoisted_286, _toDisplayString(_ctx.directT('settings.leadsSettings.editCard.subtitle')), 1)
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.showAreaModal = false)),
                  class: "w-8 h-8 bg-white/30 hover:bg-white/40 rounded-lg flex items-center justify-center transition-all duration-200 border border-white/20"
                }, _cache[141] || (_cache[141] = [
                  _createElementVNode("svg", {
                    class: "w-4 h-4 text-white",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M6 18L18 6M6 6l12 12"
                    })
                  ], -1)
                ]))
              ])
            ]),
            _createElementVNode("div", _hoisted_287, [
              _createElementVNode("div", null, [
                _createElementVNode("label", _hoisted_288, _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.cardName')), 1),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.editingArea.title) = $event)),
                  type: "text",
                  placeholder: _ctx.directT('settings.leadsSettings.cardCreation.cardNamePlaceholder'),
                  class: "w-full px-3 py-2.5 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-green-100 focus:border-green-500 bg-gray-50 text-gray-900 transition-all duration-300 placeholder:text-gray-400"
                }, null, 8, _hoisted_289), [
                  [_vModelText, _ctx.editingArea.title]
                ])
              ]),
              _createElementVNode("div", _hoisted_290, [
                _createElementVNode("div", _hoisted_291, [
                  _cache[142] || (_cache[142] = _createElementVNode("div", { class: "w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center" }, [
                    _createElementVNode("svg", {
                      class: "w-4 h-4 text-white",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                      })
                    ])
                  ], -1)),
                  _createElementVNode("div", null, [
                    _createElementVNode("h5", _hoisted_292, _toDisplayString(_ctx.editingArea.title || _ctx.directT('settings.leadsSettings.cardCreation.cardNamePreview')), 1),
                    _createElementVNode("p", _hoisted_293, _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.customCard')), 1)
                  ])
                ]),
                _createElementVNode("p", _hoisted_294, _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.previewDescription')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_295, [
              _createElementVNode("div", _hoisted_296, _toDisplayString(_ctx.directT('settings.leadsSettings.editCard.configureSettings')), 1),
              _createElementVNode("div", _hoisted_297, [
                _createElementVNode("button", {
                  onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.showAreaModal = false)),
                  class: "px-4 py-2 text-gray-700 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 hover:border-gray-300 transition-all duration-200 text-sm font-medium"
                }, _toDisplayString(_ctx.directT('settings.leadsSettings.cardCreation.cancel')), 1),
                _createElementVNode("button", {
                  onClick: _cache[51] || (_cache[51] = 
//@ts-ignore
(...args) => (_ctx.saveArea && _ctx.saveArea(...args))),
                  disabled: !_ctx.editingArea.title.trim(),
                  class: "px-6 py-2 text-white rounded-lg hover:shadow-lg disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 text-sm font-medium shadow-md disabled:shadow-none",
                  style: {"background":"linear-gradient(135deg, #10B981 0%, #059669 50%, #047857 100%)"}
                }, _toDisplayString(_ctx.directT('settings.leadsSettings.editCard.createCard')), 9, _hoisted_298)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.toastMessage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 7,
          class: _normalizeClass(["fixed bottom-4 right-4 left-4 md:left-auto md:max-w-md p-4 rounded-md shadow-lg transform transition-transform duration-300 z-50 flex items-center justify-between", { 
        'bg-green-600 text-white': _ctx.toastType === 'success', 
        'bg-red-600 text-white': _ctx.toastType === 'error', 
        'bg-blue-600 text-white': _ctx.toastType === 'info' 
      }])
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.toastMessage), 1),
          _createElementVNode("button", {
            onClick: _cache[52] || (_cache[52] = 
//@ts-ignore
(...args) => (_ctx.closeToast && _ctx.closeToast(...args))),
            class: "ml-4 text-white hover:text-gray-300"
          }, "×")
        ], 2))
      : _createCommentVNode("", true)
  ]))
}